<app-toast [message]="toast.message"></app-toast>

<div class="row">

  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    <div class="card border-0">
      <h4 class="card-header border-0">
        Alert results
      </h4>
      <div class="card-body">
        <div class="mb-3">
          <div class="row align-items-center">
            <div class="col-aut">
              This page shows the latest
            </div>
            <div class="col-auto">
              <select class="form-control form-control-sm" name="days" [(ngModel)]="days" [disabled]="isLoading.search" (change)="search(alert)">
                <option value="" selected disabled>Select days back</option>
                <option value="1">1 day</option>
                <option value="3">3 days</option>
                <option value="7">7 days</option>
              </select>
            </div>
            <div class="col-auto">
              of results for the alert below.
            </div>
          </div>
          The result snippets are larger compared to the email ones.<br>
          <div class="custom-control custom-switch ms-1 my-1">
            <input type="checkbox" class="custom-control-input cursor-pointer" id="switch-comments" name="showFullDocuments"
              [(ngModel)]="showFullDocuments" (change)="showFullDocumentsSwitch()" [checked]="showFullDocuments"
              [disabled]="isLoading.search">
            <label class="custom-control-label cursor-pointer" for="switch-comments">
              Toggle <i>full</i> documents
              <i class="fa fa-exclamation-triangle cursor-pointer" data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="This may slow down your computer due to too large documents"></i>
            </label>
          </div>
        </div>
        @if (alert) {
          <div class="bg-light border rounded-lg px-3 py-2 mb-3">
            <span>Alert name: {{alert.name}}<br></span>
            <app-alert-query [alert]="alert"></app-alert-query>
          </div>
        }
        <app-result [isLoading]="isLoading.search" [results]="results"></app-result>
      </div>
    </div>
  </div>

</div>
